import React from 'react'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'

import AliadaProfile from './AliadaProfile'
import ReplacementAliadaProfile from './ReplacementAliadaProfile'
import * as fromAliada from '@src/redux/modules/aliada'
import * as fromService from '@src/redux/modules/service'
import * as qs from 'utils/querystring'

function selectAliadaProfile (props) {
  const {
    replaceAliada,
    forBookingId: bookingId,
    bookingTypeId
  } = qs.parse(props.location.search)
  const Component = replaceAliada ? ReplacementAliadaProfile : AliadaProfile

  return React.createElement(
    Component,
    {
      ...props,
      bookingId,
      bookingTypeId
    }
  )
}

const mapStateToProps = (state, ownProps) => {
  const {
    replaceAliada,
    estimatedHours
  } = qs.parse(ownProps.location.search)

  const estimatedServiceHours = replaceAliada ? estimatedHours : fromService.getService(state).estimatedHours

  return {
    fetching: state[fromAliada.constants.NAME].fetching,
    error: state[fromAliada.constants.NAME].error,
    aliadas: state.entities.aliadas,
    aliadaId: ownProps.params.aliadaId,
    estimatedServiceHours
  }
}

const mapDispatchToProps = {
  fetchAliada: fromAliada.fetchAliada,
  updateService: fromService.updateNewService,
  push,
  goBack
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(selectAliadaProfile)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/AliadaProfile/AliadaProfileContainer.js